export default __webpack_public_path__ + "static/media/opravchybu.cb62ef50.png";